module.exports = __webpack_public_path__ + "static/media/image17.fb10a827.JPG";